import React from 'react';
import { Select, DatePicker, Checkbox, Typography } from 'antd';
import moment from 'moment';
import { IBestDataset } from '../../../../../../types/analytics';
import { DateFormat } from '../../../../../../utils/StaticVariable';
import styles from '../../Layout/AnalyticsLayout.module.scss';

const { Text } = Typography;

interface TidalLevelInputFormProps {
  datasets: IBestDataset[];
  dataset: string | null;
  onSelectDataset: (value: string) => void;
  categories: string[];
  variables: any[];
  variableX: any;
  onVariableChange: (value: any) => void;
  startDate: moment.Moment;
  endDate: moment.Moment;
  onStartDateChange: (date: any) => void;
  onEndDateChange: (date: any) => void;
  disabledStartDate: (date: any) => boolean;
  disabledEndDate: (date: any) => boolean;
  isForAllAnalytics: boolean;
  onCheckboxChange: () => void;
  supported: boolean;
  isLoading: boolean;
  isOfflineDataset: boolean;
}

export default function TidalLevelInputForm({
  datasets,
  dataset,
  onSelectDataset,
  categories,
  variables,
  variableX,
  onVariableChange,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  disabledStartDate,
  disabledEndDate,
  isForAllAnalytics,
  onCheckboxChange,
  supported,
  isLoading,
  isOfflineDataset,
}: TidalLevelInputFormProps) {
  return (
    <div className={styles.formRow}>
      <div className={`${styles.formItem} ${styles.datasetItem}`}>
        <Text>Dataset</Text>
        <Select
          id='Analytics-TidalLevel-Dataset_Input'
          value={dataset}
          onChange={onSelectDataset}
          placeholder='Select dataset'
          disabled={isLoading}
        >
          {categories.map((category: string) => (
            <Select.OptGroup key={category} label={category}>
              {datasets
                .filter((item) => item.label === category)
                .map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.value}
                  </Select.Option>
                ))}
            </Select.OptGroup>
          ))}
        </Select>
      </div>

      <div className={`${styles.formItem} ${styles.variableItem}`}>
        <Text>Variable</Text>
        <Select
          id='Analytics-TidalLevel-Variable_Input'
          placeholder='Select variable'
          onChange={onVariableChange}
          value={variableX?.Index}
          disabled={isOfflineDataset || isLoading || !supported}
        >
          {variables
            .filter((item) => item.Name !== 'Time')
            .map((item) => (
              <Select.Option key={item.Index} value={item.Index}>
                {item.Name}
              </Select.Option>
            ))}
        </Select>
      </div>

      <div className={`${styles.formItem} ${styles.dateItem}`}>
        <Text>Start Date</Text>
        <DatePicker
          id='Analytics-TidalLevel-StartDate_Input'
          value={moment(startDate)}
          disabledDate={disabledStartDate}
          onChange={onStartDateChange}
          format={DateFormat}
          disabled={isOfflineDataset || isLoading || !supported}
        />
      </div>

      <div className={`${styles.formItem} ${styles.dateItem}`}>
        <Text>End Date</Text>
        <DatePicker
          id='Analytics-TidalLevel-EndDate_Input'
          value={moment(endDate)}
          disabledDate={disabledEndDate}
          onChange={onEndDateChange}
          format={DateFormat}
          disabled={isOfflineDataset || isLoading || !supported}
        />
      </div>

      <div className={`${styles.formItem} ${styles.checkboxItem}`}>
        <Checkbox
          id='Analytics-TidalLevel-Checkbox'
          disabled={isOfflineDataset || isLoading || !supported}
          checked={isForAllAnalytics}
          onChange={onCheckboxChange}
        />
        <Text onClick={onCheckboxChange} style={{ cursor: 'pointer' }}>
          Use this period for all analytics
        </Text>
      </div>
    </div>
  );
}
